/**
 * Utility functions for text processing
 */

/**
 * Removes trailing semicolons from text
 * @param text - The text to process
 * @returns The text with trailing semicolons removed
 */
export const removeSemicolons = (text: string | undefined | null): string => {
  if (!text) return '';
  return text.replace(/:+$/, '');
};

/**
 * Removes trailing punctuation (semicolons, colons) from text
 * @param text - The text to process
 * @returns The text with trailing punctuation removed
 */
export const removeTrailingPunctuation = (text: string | undefined | null): string => {
  if (!text) return '';
  return text.replace(/[:]+$/, '');
};
